/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const isCustomFilter = (filterId: string): boolean => /^\d+$/.test(filterId);
export const isSystemFilter = (filterId: string): boolean => /^-\d+$/.test(filterId);

/**
 * Check if provided value matches the format of a backend filterId *(not to be confused with
 * checking the existence of an ID on the backend)*.
 *
 * NOTE -
 * Some NIN experiences such as project-scope-issue-navigator (PIN) also use key-based filter IDs
 * (such as 'myopenissues') which are NOT considered to be a true filterId as the JQL is stored
 * on the **frontend ONLY**. This function guards against such values.
 *
 * - Custom Filter ID's are positive numbers (1,2,3, ...)
 * - Global System Filters(-1,-2.-3, ...)
 */
export const isFilterId = (value?: string): boolean => value !== undefined && /^-?\d+$/.test(value);
